import { render } from "./ServiceCenterIcon.vue?vue&type=template&id=9968b4fa"
import script from "./ServiceCenterIcon.vue?vue&type=script&lang=js"
export * from "./ServiceCenterIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ServiceCenterIcon.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "9968b4fa"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('9968b4fa', __exports__)) {
    api.reload('9968b4fa', __exports__)
  }
  
  module.hot.accept("./ServiceCenterIcon.vue?vue&type=template&id=9968b4fa", () => {
    api.rerender('9968b4fa', render)
  })

}


export default __exports__